import { Loading } from 'element-ui';
const loading = {
        isLoading:false,
        message:'',
        show:function(msg){
            if(loading.isLoading==false){
                loading.isLoading = true;
                loading.message = msg || '请求中...';
                loading.loading = Loading.service({
                    lock: true,
                    text: loading.message,
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                  });
            }
        },
        hide:function(message){
            loading.isLoading = false;
            if(loading.loading){
                loading.loading.close();
            }
        }
    }
export default loading


// WEBPACK FOOTER //
// ./src/common/js/loading.js